import { motion } from 'framer-motion';

import { formatNumberToDigits } from '@src/utils';

import styles from './WebinarLobbyBackground.module.scss';

const AnimatedBox = ({ value, label }: { value: number; label: string }) => (
  <div className={styles.countdownSection}>
    <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} className={styles.timerBox}>
      {formatNumberToDigits(value)}
    </motion.div>
    <span className={styles.timerLabel}>{label}</span>
  </div>
);

export default AnimatedBox;
